module.exports = __webpack_public_path__ + "img/00021.80475b80.webp";